import { Reducer } from 'redux';
import { IAction } from '../types';
import LocalStore from '@/utils/store';

export interface LiveStatusState {
  isLiving: boolean;
  liveStartTime?: number;
  liveSettings?: any;
  anchorUid?: number;
  roomId?: number;
}

const localLiveStatus = LocalStore.getValue<LiveStatusState>('LIVE_STATUS_STATE') || {};

export const liveStatusInfo: LiveStatusState = {
  isLiving: false,
  liveStartTime: undefined,
  liveSettings: undefined,
  anchorUid: undefined,
  roomId: undefined,
  ...localLiveStatus
};

export const setLiveStatusInfo: (payload: LiveStatusState) => IAction<LiveStatusState> = (
  payload: LiveStatusState
) => ({
  type: 'setLiveStatusInfo',
  payload
});

export const startLive: (payload: {
  liveSettings: any;
  anchorUid: number;
  roomId: number;
}) => IAction<any> = payload => ({
  type: 'startLive',
  payload
});

export const endLive: () => IAction<any> = () => ({
  type: 'endLive',
  payload: {}
});

const liveStatusReducer: Reducer<LiveStatusState, IAction<any>> = (state = liveStatusInfo, action: IAction<any>) => {
  const { type, payload } = action;

  let newState: LiveStatusState;

  switch (type) {
    case 'setLiveStatusInfo':
      newState = { ...payload };
      break;

    case 'startLive':
      newState = {
        ...state,
        isLiving: true,
        liveStartTime: Date.now(),
        liveSettings: payload.liveSettings,
        anchorUid: payload.anchorUid,
        roomId: payload.roomId
      };
      break;

    case 'endLive':
      newState = {
        ...state,
        isLiving: false,
        liveStartTime: undefined,
        liveSettings: undefined,
        anchorUid: undefined,
        roomId: undefined
      };
      break;

    default:
      return state;
  }

  LocalStore.setValue('LIVE_STATUS_STATE', newState);
  return newState;
};

export default liveStatusReducer;
